import type { AuthResponse, FinishAuthResponse, JWTResponse, AssessTurnstileResponse } from "../api/auth";
import sign from "jwt-encode";
import { decodeJWT } from "../public/lib/helpers/jwt";

export const authAnonymous = (): Promise<JWTResponse> => {
  throw new Error("Demo mode should never attempt to authenticate");
};

export const start = (): Promise<AuthResponse> => {
  throw new Error("Demo mode should never attempt to start an auth path");
};

export const assessTurnstile = async (): Promise<AssessTurnstileResponse> => {
  return Promise.resolve({
    success: true,
    token: "turnstile-token",
    // The valid until just skips the withCaptcha check
    valid_until: new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString(),
    // Don't think if putting in the past is relevant, but we need to return something
    retry_at: new Date(Date.now() - 1000).toISOString()
  });
};

export const exchangeTemporaryJWT = async (
  fingerprint: string,
  tempJwt: string,
  turnstileToken?: string
): Promise<JWTResponse> => {
  return Promise.resolve({
    success: true,
    jwt: sign(
      {
        exp: decodeJWT(tempJwt).exp,
        fooji_data: { ...decodeJWT(tempJwt).fooji_data, fingerprint, turnstileToken }
      },
      "dummySecret"
    )
  });
};

export const finishYoutube = (token: string): Promise<FinishAuthResponse> => {
  return Promise.resolve({
    jwt: "youtube-jwt",
    accessToken: token
  });
};
